import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import {
  Route,
  Redirect,
  Switch,
  withRouter,
} from 'react-router-dom';
import IdleTimer from 'react-idle-timer';

import { signOut } from 'actions/auth';
import Login from './pages/Auth/Login';
import SetNewPassword from './pages/Auth/SetNewPassword';
import Forgot from './pages/Auth/Forgot';
import BorrowerMerchant from './pages/BorrowerMerchantApply/';
import Merchant from './pages/MerchantApply/';
import Dashboard from './pages/Dashboard';
import ApplicationReview from './pages/ApplicationReview';
import PreSelectionReview from './pages/ApplicationReview/PreSelectionReview';
import ApplicationDetail from './pages/ApplicationDetail';
import TextApplyFrontend from './pages/TextApplyFrontend';
import Profile from './pages/Profile';
import FundingInformation from './pages/FundingInformation';
import RequestBrochures from './pages/RequestBrochures';
import WebBanners from './pages/WebBanners';
import EmailApp from './pages/EmailApp';
import TodoList from './pages/TodoList';
import CertificateSettlement from './pages/CertificateSettlement';
import DscComponent from './pages/DscComponent';
import Congrats from './pages/Congrats';
import FreshStart from './pages/FreshStart';
import PreSelectionStart from './pages/PreSelection/Start';
import PreSelectionApproved from './pages/PreSelection/Approved';
import PreSelectionFailed from './pages/PreSelection/Failed';
import isApplicationFiltersLoaded from 'components/Hoc/isApplicationFiltersLoaded';
import MarketingResources from './pages/MarketingResources';
import { appConfig } from 'config/appConfig';
import TrainingCenter from './pages/TrainingCenter';

const PrivateRoute = ({ component: InternalComponent, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
        const token = localStorage.getItem('idToken');
        return token ?
          <InternalComponent {...props} />
        :
          <Redirect
            to={{
              pathname: '/',
              // eslint-disable-next-line
              state: { from: props.location },
            }}
          />;
      }
    }
  />
);

const PublicRoute = ({ component: InternalComponent, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
        const token = localStorage.getItem('idToken');
        return !token ?
          <InternalComponent {...props} />
        :
          <Redirect
            to={{
              pathname: '/dashboard',
              // eslint-disable-next-line
              state: { from: props.location },
            }}
          />;
      }
    }
  />
);

const routes = [
  {
    name: 'Login',
    pathname: '/',
    component: Login,
    exact: true,
    wrapper: PublicRoute,
  },
  {
    name: 'Forgot',
    pathname: '/forgot',
    component: Forgot,
    exact: true,
    wrapper: PublicRoute,
  },
  {
    name: 'New password',
    pathname: '/set-new-password',
    component: SetNewPassword,
    exact: true,
    wrapper: PublicRoute,
  },
  {
    name: 'BorrowerMerchant',
    pathname: '/dashboard/borrowers-merchant',
    component: BorrowerMerchant,
    wrapper: PrivateRoute,
  },
  {
    name: 'Merchant',
    pathname: '/dashboard/merchants',
    component: Merchant,
    exact: true,
    wrapper: PrivateRoute,
  },
  {
    name: 'Application Review',
    pathname: '/dashboard/application-review/action/:statusCode/:searchQuery',
    component: ApplicationReview,
    wrapper: PrivateRoute,
  },
  {
    name: 'Application Review',
    pathname: '/dashboard/application-review/action/:statusCode',
    component: ApplicationReview,
    wrapper: PrivateRoute,
  },
  {
    name: 'Application Review',
    pathname: '/dashboard/pre-selection-review/action/:statusCode',
    component: PreSelectionReview,
    wrapper: PrivateRoute,
  },
  {
    name: 'Application Detail',
    pathname: '/dashboard/application-detail',
    component: ApplicationDetail,
    wrapper: PrivateRoute,
  },
  {
    name: 'Text Apply',
    pathname: '/dashboard/text-apply',
    component: TextApplyFrontend,
    wrapper: PrivateRoute,
  },
  {
    name: 'Profile Settings',
    pathname: '/dashboard/profile',
    component: Profile,
    wrapper: PrivateRoute,
  },
  {
    name: 'Funding Information',
    pathname: '/dashboard/funding-information',
    component: FundingInformation,
    wrapper: PrivateRoute,
  },
  {
    name: 'Request Brochures',
    pathname: '/dashboard/request-brochures',
    component: RequestBrochures,
    wrapper: PrivateRoute,
  },
  {
    name: 'Get Website Banners',
    pathname: '/dashboard/web-banners',
    component: WebBanners,
    wrapper: PrivateRoute,
  },
  {
    name: 'Email App to Borrower Form',
    pathname: '/dashboard/email-app',
    component: EmailApp,
    wrapper: PrivateRoute,
  },
  {
    name: 'Congrats Page',
    pathname: '/dashboard/congrats',
    component: Congrats,
    wrapper: PrivateRoute,
  },
  {
    name: 'Todo list page',
    pathname: '/dashboard/todo-list',
    component: TodoList,
    wrapper: PrivateRoute,
  },
  {
    name: 'Certificate Settlement',
    pathname: '/dashboard/settlement',
    component: CertificateSettlement,
    wrapper: PrivateRoute,
  },
  {
    name: 'DSC',
    pathname: '/dashboard/dsc',
    component: DscComponent,
    wrapper: PrivateRoute,
  },
  {
    name: 'FreshStart',
    pathname: '/dashboard/freshstart',
    component: FreshStart,
    wrapper: PrivateRoute,
  },
  {
    name: 'Dashboard',
    pathname: '/dashboard',
    component: isApplicationFiltersLoaded(Dashboard),
    wrapper: PrivateRoute,
  },
  {
    name: 'Pre selection tool',
    pathname: '/pre-selection/start',
    component: PreSelectionStart,
    wrapper: PrivateRoute,
  },
  {
    name: 'Pre-selected screen',
    pathname: '/fsl/pre-selected',
    component: PreSelectionApproved,
    wrapper: PrivateRoute,
  },
  {
    name: 'Pre-selection failed screen',
    pathname: '/fsl/pre-selection-failed',
    component: PreSelectionFailed,
    wrapper: PrivateRoute,
  },
  {
    name: 'Marketing Resources',
    pathname: '/resources',
    component: MarketingResources,
    wrapper: PrivateRoute,
  },
  {
    name: 'TrainingCenter',
    pathname: '/trainingcenter',
    component: TrainingCenter,
    wrapper: PrivateRoute,
  },
];

const ParentRoute = () => {
  const dispatch = useDispatch();
  const idleTimer = useRef(null);

  const onIdle = () => {
    localStorage.getItem('idToken') && dispatch(signOut());
  };

  const addPageSenseScript = () => {
    const scriptTag = document.createElement('script');
    scriptTag.src = `https://cdn.pagesense.io/js/lendingusa/${appConfig.pageSenseId}.js`;
    document.head.appendChild(scriptTag);
  };

  useEffect(() => {
    if (appConfig.pageSenseId) {
      addPageSenseScript();
    }
  }, []);

  return (

    <IdleTimer
      ref={idleTimer}
      element={document}
      onIdle={onIdle}
      timeout={1000 * 60 * 60}
    >
      <Switch>
        {routes.map((route, index) => (
          <route.wrapper
            component={route.component}
            key={index}
            path={route.pathname}
            exact={route.exact || false}
          />
        ))}
        <Redirect to="/" />
      </Switch>
    </IdleTimer>
  );
};

PublicRoute.propTypes = {
  component: PropTypes.any.isRequired,
};

PrivateRoute.propTypes = {
  component: PropTypes.any.isRequired,
};

ParentRoute.propTypes = {

};

export default withRouter(ParentRoute);



// WEBPACK FOOTER //
// ./src/containers/App.js